import { AxiosResponse } from "axios";
import { axiosInstance }
	from "./axiosInstance"
import { CambioPeticion, CambioPreview, CambioPromoDTO, CambioResultado } from "../../components/promos/cambiarPromocionTipos";
import { AdvisorCandidateDTO, AdvisorSelection, EnrollmentHistoryDTO } from "../../models/EnrollmentHistoryDTO";

export class EnrollmentService {

	/** Cambiar Promoción (CONTRATO §3): lo que tiene la matrícula, con quién va ligada, las opciones y si esta persona puede cambiarla. */
	getCambioPromo = async (campusId: number, enrollmentId: number) =>
		axiosInstance.get<CambioPromoDTO>(`/admin/campus/${campusId}/enrollments/${enrollmentId}/_cambioPromo`);

	/** Qué Va a Pasar por persona (solo lectura) y el previewHash que se manda al confirmar. */
	previewCambioPromo = async (campusId: number, enrollmentId: number, payload: CambioPeticion) =>
		axiosInstance.post<CambioPreview>(`/admin/campus/${campusId}/enrollments/${enrollmentId}/_cambioPromo/_preview`, payload);

	/** Confirma el cambio: aplica, deja la En Camino o la manda a aprobación. 409 = la cuenta cambió desde la vista previa. */
	cambiarPromo = async (campusId: number, enrollmentId: number, payload: CambioPeticion & { reason: string; previewHash: string; advisors?: any[] }) =>
		axiosInstance.post<CambioResultado>(`/admin/campus/${campusId}/enrollments/${enrollmentId}/_cambioPromo`, payload);

	async searchEnrollments(campusId: number, scheduleId: number) {
		const URL: string = `/admin/
            campus/${campusId}/
            schedules/${scheduleId}/
            _students`.replace(/\s+/g, "");
		const response = await axiosInstance.get(URL);
		return response;
	}

	/** People who can be credited as asesora of an enrollment in this campus. */
	async getAdvisorCandidates(campusId: number): Promise<AxiosResponse<AdvisorCandidateDTO[]>> {
		return axiosInstance.get<AdvisorCandidateDTO[]>(`/admin/campus/${campusId}/enrollments/_advisorCandidates`);
	}

	/** Replace the advisors of an enrollment (restricted server-side to supervisors / sales direction). */
	async updateAdvisors(campusId: number, studentId: number, enrollmentId: number, advisors: AdvisorSelection[]): Promise<AxiosResponse> {
		const payload = {
			advisors: advisors.map((advisor) => ({ userId: advisor.userId, sharePercentage: advisor.sharePercentage }))
		};
		return axiosInstance.put(`/admin/campus/${campusId}/students/${studentId}/enrollments/${enrollmentId}/_advisors`, payload);
	}

	/** Every enrollment of the student with who/when, advisors, notes and attendance summary. */
	async getStudentHistory(campusId: number, studentId: number): Promise<AxiosResponse<EnrollmentHistoryDTO[]>> {
		return axiosInstance.get<EnrollmentHistoryDTO[]>(`/admin/campus/${campusId}/students/${studentId}/_history`);
	}
}